import { IOverflowSetItemProps } from '@fluentui/react/lib/OverflowSet';
import loc from 'owa-localize';
import getOfficeAppItem from './getOfficeAppItem';
import { isFeatureEnabled } from 'owa-feature-flags';
import { moreAppsTitle } from './AppDrawerButton.locstring.json';
import { appWord } from 'owa-locstrings/lib/strings/appword.locstring.json';
import { appExcel } from 'owa-locstrings/lib/strings/appexcel.locstring.json';
import { appPowerPoint } from 'owa-locstrings/lib/strings/apppowerpoint.locstring.json';
import { OneDriveText } from 'owa-locstrings/lib/strings/onedrivetext.locstring.json';

export default function getAllOfficeAppItems(): IOverflowSetItemProps[] {
    const officeAppItems: IOverflowSetItemProps[] = [
        getOfficeAppItem('Word', loc(appWord)),
        getOfficeAppItem('Excel', loc(appExcel)),
        getOfficeAppItem('Powerpoint', loc(appPowerPoint)),
        getOfficeAppItem('OneDrive', loc(OneDriveText)),
    ].filter(railItem => !!railItem);

    if (isFeatureEnabled('tri-metaOsRail')) {
        officeAppItems.push({
            key: 'appDrawer',
            text: loc(moreAppsTitle),
            ariaLabel: loc(moreAppsTitle),
            name: loc(moreAppsTitle),
            isAppDrawerItem: true,
        });
    }

    if (officeAppItems.length === 0) {
        // If there are no office app items then return empty list instead of adding
        // placeholder so that we can hide the whole rail.
        return [];
    }
    return officeAppItems;
}
